var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-search"},[_c('van-search',{attrs:{"show-action":"","placeholder":_vm.placeholder},on:{"search":_vm.onSearch},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('div',{on:{"click":_vm.onSearch}},[_vm._v("搜索")])]},proxy:true}]),model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }